module.exports = (s, e) => Array.prototype.slice.call((e || document).querySelectorAll(s));